import { Component, OnInit, Directive, Input, ViewChild, Output, EventEmitter } from '@angular/core';
// import {ExternalUserComponent} from '../external-user.component'
import { Routes, RouterModule, ActivatedRoute, Router } from '@angular/router';
import { Location } from '@angular/common';
import { ExternalUserService } from '@externaluserservice/external-user.service';
import { AdvancePaymentDetails } from '@externalusermodel/AdvancePaymentDetails';
import { ChaseAdvancePaymentUIDRequest, ChaseUIDRequest } from '@externalusermodel/AdvancePayment';
import { ChaseProfileTransactionData } from '@externalusermodel/ChaseProfileTransactionData';
import { TransactionHistoryUpdate } from '@externalusermodel/Order';
@Component({
    selector: 'app-advance-details',
    templateUrl: './advance-details.component.html',
    styleUrls: ['./advance-details.component.css'],
    providers: [ExternalUserService],
    standalone: false
})


export class AdvanceDetailsComponent implements OnInit {

  // @Input() advanceAmnt:any;
  advanceAmount: string;
  comments: any;
  station: any;
  accountExecutive: any;
  advanceAmounttmp: any;
  advanceAmountCC: string;
  agencyID: string;

  displayAddRefundPopUp: boolean;
  UserID: any;
  response_data: string;
  chaseURl: string;

  methodName: string;

  chaseOrderId: string;
  private sub: any;
  Amountpaying: string;
  AmountpayingACH: number;
  AmountpayingCC: number;
  uIDRequestData: ChaseUIDRequest;

  isCreateNewProfileDisabled: boolean;
  isProfileSubmitDisabled: boolean;

  selectedProfile: any;

  profileTransType: string;

  ProfileDetail: any = [];
  count: any;
  //Ajay - Button Disable
  isLoading: boolean = true;

  ShowACH: boolean;
  ShowCC: boolean;
  //   for Advance page agency
  //isChecked: boolean = false;
  isCommissionChecked: boolean = false;
  isPayment: boolean;
  InvalidAmount: boolean;
  paymenttype: string;
  Advancetotalamount: string;
  AdvancetotalamountCC: string;
  OrderagencyID: string;
  agencycomm: any;
  orderAgencyDetail: any= []
  //   for Tax changes
  isTaxChecked:boolean = false;
  AdvancepaymentID: number;
 //   for dispaly taxamount and commission amout in Advance payment page
 advanceCommAmount: string;
 advanceTaxAmount: string;
 advanceCommAmountCC: string;
 advanceTaxAmountCC: string;
 advanceGrossAmount: string;
 advanceGrossAmountCC: string;

  constructor(private route: ActivatedRoute, private externalUserService: ExternalUserService, private _location: Location, private router: Router) {
    this.displayAddRefundPopUp = false;
    this.ShowACH = false;
    this.ShowCC = false;
    //   for Advance page agency
    //this.isPayment = true;
    this.orderAgencyDetail = [];
  }

  ngOnInit() {
     //debugger;
      this.isCommissionChecked = JSON.parse(sessionStorage.getItem('comissioncheckbox'));
     this.isTaxChecked =JSON.parse(sessionStorage.getItem('taxcheckbox'));
   
   
    this.ShowACH = true;
    this.ShowCC = false;
    this.sub = this.route.params.subscribe(params => {
      this.chaseOrderId = params['chaseOrderId'];

      this.agencyID = sessionStorage.getItem('AgencyID');

      this.externalUserService.getAdvancePaymentDetails(this.chaseOrderId)
        .subscribe(
          p => {
            //debugger;
           
            let advancePaymentAmount = p;

            this.advanceAmount = parseFloat(advancePaymentAmount).toFixed(2);        
//  
         // if (this.isCommissionChecked == false || this.isCommissionChecked == null && this.isTaxChecked == false && this.isTaxChecked == null && this.isTaxChecked == undefined)
            if (this.isCommissionChecked == false && this.isTaxChecked == false)
           {
           // debugger;
         this.externalUserService.GetAdvanceDiscountDetail(Number(advancePaymentAmount)).subscribe(q => {
           this.isLoading = false;                

           this.advanceGrossAmount = q['ordGrossAmountACH'].toString().replace(/,/g, '');
           this.advanceCommAmount = q['ordAgencyamountACH'].toString().replace(/,/g, '');
           this.advanceTaxAmount = q['ordTaxACH'].toString().replace(/,/g, '');
           this.advanceAmount = q['ordTotalNetDiscountACH'].toString().replace(/,/g, '');

           this.advanceGrossAmountCC = q['ordGrossAmountCC'].toString().replace(/,/g, '');
           this.advanceCommAmountCC = q['ordAgencyamountCC'].toString().replace(/,/g, '');
           this.advanceTaxAmountCC = q['ordTaxCC'].toString().replace(/,/g, '');
           this.advanceAmountCC = q['ordTotalNetDiscountCC'].toString().replace(/,/g, '');
         });
          }
            else{
             // debugger;
              this.onChecked(event);
             this.onTaxcheckcalculation(event);
            // this.externalusercoponent.onTaxChecked;

            }
          }
        );

    });


    this.UserID = sessionStorage.getItem('userid');
  }

  // Method to go back
  goback() {
  
    this.router.navigate(['Invoice', 'advance']);

  }

  Paynowprofile(value: any) {
      //sessionStorage.setItem("advanceID", "0");

    let requestData = new TransactionHistoryUpdate();
    requestData.chaseOrderId = this.chaseOrderId;
      //   for caputring ACH and CC net amount
   requestData.ordTotalNetDiscountACH = this.advanceAmount;
   requestData.ordTotalNetDiscountCC = this.advanceAmountCC;
   

    if (value === 1) {
      this.profileTransType = 'ACH';
      requestData.transactionAmount = this.advanceAmount.toString();
    } else if (value === 2) {
      this.profileTransType = 'CC';
      requestData.transactionAmount = this.advanceAmountCC.toString();
    }

    this.externalUserService.updateTransactionHistory(requestData).subscribe(
      response => {
        let status = response;

        if (status === 'Success') {
          this.router.navigate(['MediaPayPayment', 'Advance', this.profileTransType, this.chaseOrderId]);
        }
      });

  }
  onRadioACHChecked(event) {
    if (event.target.checked == true) {
      this.ShowACH = true;
      this.ShowCC = false;

    }
  }

  onRadioCCChecked(event) {
    if (event.target.checked == true) {
      this.ShowCC = true;
      this.ShowACH = false;

    }
  }

  //   for Advance page check box for agency commission
    onChecked(event) {
     //debugger;
     //if (event.target.checked === false || event.target.checked === undefined) 
     //for only tax check
    // if (this.isTaxChecked == true || this.isTaxChecked != null || this.isCommissionChecked != false || this.isCommissionChecked != null ) 
     if ((this.isTaxChecked == true && this.isCommissionChecked == false )|| (this.isTaxChecked == false && this.isCommissionChecked==true ))
     {
      //debugger;
    // this.isChecked = false;
    
      this.isPayment = false;
     this.InvalidAmount = false;
  //   //debugger;
      this.Advancetotalamount = this.advanceAmount;
      this.AdvancetotalamountCC = this.advanceAmountCC;
            this.paymenttype = "Partial";
     } 
     else
      {
      // this.isCommissionChecked = true;
      this.isPayment = true;
      this.Advancetotalamount = this.advanceAmount;
      this.AdvancetotalamountCC = this.advanceAmountCC;
       this.paymenttype = "Full";
      //  if (this.isTaxChecked === undefined || this.isTaxChecked === null)
      //  {
      //   this.isTaxChecked = false;
      //  }
      //  else 
      //  {
      //  // 
      //  this.isTaxChecked =JSON.parse(sessionStorage.getItem('taxcheckbox'));

      //  }
      }
     this.reCalculateAgency(this.Advancetotalamount, this.OrderagencyID, this.paymenttype,this.isTaxChecked, this.isCommissionChecked);
   }
  

//   onChecked(event) 
//   {
//     debugger;
      
//     //this.isChecked is for commision check box;
//     this.isTaxChecked = JSON.parse(sessionStorage.getItem('taxcheckbox'))
//      this.isChecked = JSON.parse(sessionStorage.getItem('comissioncheckbox'))
//      this.isPayment = false;
//      this.InvalidAmount = false;
//  //   //debugger;
//      this.Advancetotalamount = this.advanceAmount;
//      this.AdvancetotalamountCC = this.advanceAmountCC;
//      if (this.isChecked === undefined || this.isChecked === null && this.isTaxChecked != null && this.isTaxChecked != undefined)
//     {
//      this.isChecked = false;
//      this.isTaxChecked = true;
//      this.paymenttype = "Partial";

//     }
//     else 
//     {
//     // 
//     //this.isTaxChecked =JSON.parse(sessionStorage.getItem('taxcheckbox'));
//     this.isChecked = true;
//      this.paymenttype = "full";

//     }
       
//     //    this.isChecked = true;
//     //  this.isPayment = true;
//     //  this.Advancetotalamount = this.advanceAmount;
//     //  this.AdvancetotalamountCC = this.advanceAmountCC;
//     //   this.paymenttype = "Full";
//     //   if (this.isTaxChecked === undefined || this.isTaxChecked === null)
//     //   {
//     //    this.isTaxChecked = false;
//     //   }
//     //   else 
//     //   {
//     //   // 
//     //   this.isTaxChecked =JSON.parse(sessionStorage.getItem('taxcheckbox'));

//     //   }
//     this.reCalculateAgency(this.Advancetotalamount, this.OrderagencyID, this.paymenttype,this.isTaxChecked);
  
//    }
    
   reCalculateAgency(event, OrderagencyID, paymenttype,isTaxChecked,isCommissionChecked)
   {
    let advancePaymentDetailsId = sessionStorage.getItem('advanceID');
  //    //debugger;
     this.InvalidAmount = false;
  // //   //this.InvalidAmount2 = false;
  // //   // Button Disable
       this.isLoading = true;
       this.OrderagencyID = sessionStorage.getItem('AgencyID');
       
       //this.externalUserService.GetAdvanceAgencyDetail(this.Advancetotalamount, this.OrderagencyID,this.paymenttype,advancePaymentDetailsId,this.isTaxChecked)

         this.externalUserService.GetAdvanceAgencyDetail(Number(this.Advancetotalamount), this.OrderagencyID, this.paymenttype, advancePaymentDetailsId, this.isTaxChecked, this.isCommissionChecked).subscribe(
         p => {
            //Ajay - Button Disable
          this.isLoading = false;
      //  this.orderAgencyDetail = sessionStorage.getItem('orderAgencyDetail');
   // //        // this.advanceAmountCC = parseFloat(p).toFixed(2);
        this.advanceAmount = p['ordTotalNetDiscountACH'].toString().replace(/,/g, '');
         this.advanceAmountCC = p['ordTotalNetDiscountCC'].toString().replace(/,/g, '');

         //   Added to display in Advance payment page.
         this.advanceCommAmount = p['ordAgencyamountACH'].toString().replace(/,/g, '');
         this.advanceTaxAmount = p['ordTaxACH'].toString().replace(/,/g, '');
         this.advanceCommAmountCC = p['ordAgencyamountCC'].toString().replace(/,/g, '');
         this.advanceTaxAmountCC = p['ordTaxCC'].toString().replace(/,/g, '');
         this.advanceGrossAmount = p['ordGrossAmountACH'].toString().replace(/,/g, '');
         this.advanceGrossAmountCC = p['ordGrossAmountCC'].toString().replace(/,/g, '');
      },
     );
   }

   reCalculateAgencyTax(event, OrderagencyID, paymenttype,isTaxChecked)
 {
  let advancePaymentDetailsId = sessionStorage.getItem('advanceID');
   this.InvalidAmount = false;
   console.log("  2");
   this.isTaxChecked =JSON.parse(sessionStorage.getItem('taxcheckbox'));
   console.log(this.isTaxChecked + 'Comment in reCalculateAgencyTax');
     this.isLoading = true;
     this.OrderagencyID = sessionStorage.getItem('AgencyID');
    // this.externalUserService.GetAdvanceAgencyDetail(this.Advancetotalamount, this.OrderagencyID,this.paymenttype, advancePaymentDetailsId,this.isTaxChecked)
     this.externalUserService.GetAdvanceAgencyDetail(Number(this.Advancetotalamount), this.OrderagencyID,this.paymenttype,advancePaymentDetailsId,this.isTaxChecked, this.isCommissionChecked).subscribe(
       p => {
        
         this.isLoading = false;
         this.orderAgencyDetail = p;
      
       },
     );
 }

//   For Tax checkbox changes.

onTaxcheckcalculation(event) {
   //debugger;
  // console.log('  3');
//console.log(sessionStorage.getItem('taxcheckbox'));
  
  this.isTaxChecked =JSON.parse(sessionStorage.getItem('taxcheckbox'));
   // sessionStorage.setItem('taxcheckbox', JSON.stringify(this.isTaxChecked));
  //  console.log("Arind 4");
   // console.log(this.isTaxChecked);
    
          this.reCalculateAgency(this.Advancetotalamount, this.OrderagencyID, this.paymenttype, this.isTaxChecked,this.isCommissionChecked);
         // this.reCalculateAgencyTax(this.Advancetotalamount, this.OrderagencyID, this.paymenttype, this.isTaxChecked);
    
    //console.log("Advance payment page");
  
 }



}

